












































import mixins from 'vue-typed-mixins';
import AuthUtils from '@/utils/AuthUtils';
import UserUtils, { User } from '../../utils/UserUtils';
export default mixins().extend({
  data(): {
    user?: User;
    password: string;
    confirmation: string;
  } {
    return {
      user: undefined,
      password: '',
      confirmation: '',
    };
  },
  async mounted() {
    try {
      this.user = await UserUtils.api.get(this.$session?.id);
    } catch (error) {
      (this.$refs.alert as any).show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async reset() {
      try {
        if (this.user) {
          this.user.password = this.password;
          this.user.state = 'active';
          delete this.user.permissions; // permissions must not be sent
          await UserUtils.api.update(this.user);
          await AuthUtils.set(await AuthUtils.get()); // update session
          try {
            await this.$router.push({ name: 'dashboard' });
          } catch (error) {
            // doesn't matter
          }
        }
      } catch (error) {
        (this.$refs.alert as any).show('reset', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
